<template>
  <v-app>
    <v-main>
      <VLibras />
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import VLibras from "@/components/VLibras.vue";
export default {
  name: 'App',

  components: {
    VLibras
  },

  data(){
    return{
      currentUser: {},
    }
  },

  methods:{
    getRole(){
      const user = localStorage.getItem("currentUser");
      this.currentUser = JSON.parse(user);
      if (this.currentUser == null) {
        this.$store.dispatch("logout");
        this.$router.push("/login");
      }
      
      localStorage.setItem('roles', JSON.stringify(this.currentUser?.role_name));
    }
  },

  created(){
    this.getRole()
  }
};
</script>